
import React from 'react';

const WeatherHeader = ({ showBanner }) => {
  return (
    <div className={`w-full max-w-md flex justify-between mb-4 ${showBanner ? 'mt-36' : ''}`}>
      <div className="flex items-center space-x-4">
        {/* Language selector placeholder */}
      </div>
    </div>
  );
};

export default WeatherHeader;
